var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1428,
    height: 806,
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1428 265.472V0L0 806H1428V265.472Z",
    fill: "#FEF3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBg);
export default __webpack_public_path__ + "static/media/nav-bg.ff5d5db087137f279166dadc61ab3eba.svg";
export { ForwardRef as ReactComponent };